import pkg from "../../package.json";
const ASSETS_PREFIX = "/assets/shell";
export const SHELL_ASSETS_PREFIX = `${ASSETS_PREFIX}/v${pkg.version}`;
export const STATIC_ASSETS_PREFIX = `${ASSETS_PREFIX}/static`;
